import React from 'react';
import AboutSection from './components/sections/AboutSection';
import AuraSection from './components/sections/AuraSection';
import PortfolioSection from './components/sections/PortfolioSection';
import ContactSection from './components/sections/ContactSection';
import Footerbar from './components/layout/Footerbar';
import Navbar from './components/layout/Navbar';
import ARBackground from './components/animations/ARBackground';
import { useWindowScrollProgressRef } from './hooks/useWindowScrollProgressRef';

const Home = () => {
  const bgScrollRef = useWindowScrollProgressRef();

  return (
    <>
      <ARBackground scrollProgressRef={bgScrollRef} />
      <Navbar />
      <AboutSection />
      <AuraSection />
      <PortfolioSection />
      <ContactSection />
      <Footerbar />
    </>
  );
};


export default Home;

